
import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import toastr from "toastr";

import {
  GET_PAGERDUTY_SERVICES,
  UPDATE_PAGERDUTY_BLUEJAY_TEAM,
    GET_REFRESH_PAGERDUTY
} from "./actionTypes";

import {
  getPagerdutyServicesSuccess, getPagerdutyServicesFail,
  updatePagerdutyBluejayTeamSuccess, updatePagerdutyBluejayTeamFail,
    getPagerdutyRefreshSuccess, getPagerdutyRefreshFail
} from "./actions";

import {
  getPagerdutyServicesUrl,
  updatePagerdutyBluejayTeamUrl,
  getPagerdutyRefreshUrl
} from "../../helpers/fakebackend_helper";

function* onGetPagerdutyServices() {
  try {
    const response = yield call(getPagerdutyServicesUrl);
    yield put(getPagerdutyServicesSuccess(response));
  } catch (error) {
    yield put(getPagerdutyServicesFail(error.message));
  }
}

function* onUpdatePagerdutyBluejayTeam({ payload }) {
  try {
    const response = yield call(updatePagerdutyBluejayTeamUrl, payload);
    toastr.success("Pagerduty Bluejay Team updated successfully");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    yield put(updatePagerdutyBluejayTeamSuccess(response));
  } catch (error) {
    yield put(updatePagerdutyBluejayTeamFail(error.message));
  }
}

function* onGetPagerdutyRefresh() {
  try {
    const response = yield call(getPagerdutyRefreshUrl);
    yield put(getPagerdutyRefreshSuccess(response));
  } catch (error) {
    yield put(getPagerdutyRefreshFail(error.message));
  }
}


function* pagerdutyServicesSaga() {
  yield takeEvery(GET_PAGERDUTY_SERVICES, onGetPagerdutyServices);
  yield takeEvery(UPDATE_PAGERDUTY_BLUEJAY_TEAM, onUpdatePagerdutyBluejayTeam);
    yield takeEvery(GET_REFRESH_PAGERDUTY, onGetPagerdutyRefresh);
}

export default pagerdutyServicesSaga;
